import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SvgComponent } from 'haba-base-components';
import { isAwaitingSapEnrichment } from '@app/helpers';
import { UserService } from '@app/services';
import { I18nModule, UserAddressService } from 'haba-core';
import { filter, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-pending-registration-notice',
  templateUrl: './pending-registration-notice.component.html',
  styleUrls: ['./pending-registration-notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, I18nModule],
})
export class PendingRegistrationNoticeComponent {
  private userAddressService = inject(UserAddressService);
  private userService = inject(UserService);

  isCompany = toSignal(this.userService.getCurrentUser().pipe(map((user) => user?.isCompany)));

  billingAddress = toSignal(
    this.userAddressService.getAddressesLoading().pipe(
      filter((loading) => !loading),
      switchMap(() => this.userAddressService.getAddresses()),
      filter((addresses) => !!addresses?.length),
      map((addresses) =>
        addresses.find((address) => address.billingAddress && !address.habaPayerAddress)
      )
    )
  );

  pending = computed(() => !!this.isCompany() && isAwaitingSapEnrichment(this.billingAddress()));
}
